
<div class="container">
  <h1>اختر اللعبة</h1>

  <div class="game-bar">
    <!--  <div class="game" [ngClass]="{'active':activeGame ==='all'}" (click)="setActiveGame('all')">All Games</div>-->
    <div class="game" *ngFor="let game of this.eventService.Games" [ngClass]="{'active':activeGame ===game.code}"
         (click)="setActiveGame(game.code)" >
      <img src="assets/img/ramadan2022/{{ game.code }}-ramadan2022.png" class="img-responsive"/>
      <div *ngIf="activeGame ===game.code" class="active-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="34.875" height="34.875" viewBox="0 0 34.875 34.875">
          <path data-name="Icon awesome-check-circle" d="M35.438 18A17.438 17.438 0 1 1 18 .563 17.437 17.437 0 0 1 35.438 18zm-19.455 9.233L28.921 14.3a1.125 1.125 0 0 0 0-1.591l-1.591-1.595a1.125 1.125 0 0 0-1.591 0L15.188 21.665l-4.926-4.926a1.125 1.125 0 0 0-1.591 0l-1.592 1.59a1.125 1.125 0 0 0 0 1.591l7.313 7.313a1.125 1.125 0 0 0 1.591 0z" transform="translate(-.563 -.563)" style="fill:#fbc955"/>
        </svg>

      </div>
    </div>
  </div>
  <ng-container *ngIf="!eventService.loadEventTournaments; else loading">
    <ng-container *ngIf="tournaments!= 0; else nodata">
      <div class="tournament-container">
        <ng-container *ngFor="let tournament of tournaments" >
          <app-tournaments-reusable [tournament]="tournament" [backgroundBody]="'#000000'"
                                    [colorBody]="'#fbc955'" [direction]="'ar'" [fillColor]="'#fbc955'">

          </app-tournaments-reusable>

        </ng-container>

      </div>
      <div class="new_button"  routerLink="../tournaments">
        <div class="border-btn"></div>
        المزيد من البطولات
      </div>
    </ng-container>
  </ng-container>
  <ng-template #nodata >
    <div class="no-data " >
      <h2>لم يتم إنشاء بطولات حتى الآن</h2>

    </div>
  </ng-template>


  <ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
  </ng-template>

</div>
